import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('RemoteDesktopExercise', LATEST_SCHEMA_VERSION.RemoteDesktopExercise);
export default exerciseTypeVersionAdapter;